import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { InsurancesState } from '../_reducers/insurance.reducers';
import { Insurance } from '../_models/insurance.model';

export const selectInsurancesState = createFeatureSelector<InsurancesState>('insurances');

export const selectInsuranceById = (insuranceId: number) =>
  createSelector(selectInsurancesState, (insurancesState) => insurancesState.entities[insuranceId]);

export const selectInsurancesPageLoading = createSelector(
  selectInsurancesState,
  (insurancesState) => {
    return insurancesState.listLoading;
  },
);

export const selectInsurancesActionLoading = createSelector(
  selectInsurancesState,
  (insurancesState) => insurancesState.actionsloading,
);

export const selectLastCreatedInsuranceId = createSelector(
  selectInsurancesState,
  (insurancesState) => insurancesState.lastCreatedInsuranceId,
);

export const selectInsurancesPageLastQuery = createSelector(
  selectInsurancesState,
  (insurancesState) => insurancesState.lastQuery,
);
export const selectErrorState = createSelector(
  selectInsurancesState,
  (insurancesState) => insurancesState.error,
);

export const selectInsurancesInStore = createSelector(selectInsurancesState, (insurancesState) => {
  const items = (insurancesState.ids as number[])
    .map((id) => insurancesState.entities[id])
    .filter((item): item is Insurance => item !== undefined);
  return new QueryResultsModel(items, insurancesState.totalCount);
});

export const selectInsurancesShowInitWaitingMessage = createSelector(
  selectInsurancesState,
  (insurancesState) => insurancesState.showInitWaitingMessage,
);

export const selectHasInsurancesInStore = createSelector(selectInsurancesState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
